import type { DocumentModel } from "@/models/DocumentModel";

// Singleton storage for the suggestions DocumentModel. Kept in its own module
// with a *type-only* import of DocumentModel so that disposing the singleton
// (notably the global jest `afterEach`, which runs for every test in the
// project) does not pull the heavy DocumentModel runtime graph — tiptap,
// ProseMirror, Yjs, all models — into tests that never use suggestions.
let suggestionsDoc: DocumentModel | null = null;

export function getStoredSuggestionsDoc(): DocumentModel | null {
  return suggestionsDoc;
}

export function setStoredSuggestionsDoc(doc: DocumentModel): void {
  suggestionsDoc = doc;
}

export function disposeSuggestionsDoc(): void {
  suggestionsDoc = null;
}
